import { render, staticRenderFns } from "./Add-Visit-Dialog.vue?vue&type=template&id=8517727c"
import script from "./Add-Visit-Dialog.vue?vue&type=script&lang=js"
export * from "./Add-Visit-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports